import React from 'react'
import { formatDate } from "../../../utils/convertDate";
import { FormatMoney } from "../../../utils/formatMoney";

const DeclinedTransaction = ({decline}) => {
  return (
    <div className="my-12">
      <h2 className=" uppercase letter-spacing font-semibold text-gray-800 mt-5">
        Declined Transactions{" "}
      </h2>
      <hr />
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full table-fixed divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800"
                    >
                      Transaction Date
                    </th>
                    <th
                      scope="col"
                      className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 "
                    >
                      Value Date
                    </th>
                    <th
                      scope="col"
                      className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800"
                    >
                      Narration
                    </th>
                    <th
                      scope="col"
                      className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 "
                    >
                      Credit
                    </th>
                    <th
                      scope="col"
                      className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800"
                    >
                      Debit
                    </th>
                    <th
                      scope="col"
                      className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 "
                    >
                      Balance
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {decline != null && decline.length != 0 ? decline?.map((person) => (
                    <tr className="bg-gray-50">
                      <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                        {formatDate(person?.transactionDate)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                        {formatDate(person?.valueDate)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                        {person?.narration}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                        {FormatMoney(person?.credit)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                        {FormatMoney(person?.debit)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                        {FormatMoney(person?.balance)}
                      </td>
                    </tr>
                  )) : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
</div>
  )
}

export default DeclinedTransaction

